<template lang="pug">
  div
    .wcity
      p 本服务由云南合道康成信息技术有限公司提供技术支持
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.wcity {
  text-align: center;
  color: #b3b6bf;
  margin-top: 1em;
  margin-bottom: 1em;
}
</style>
